import React, { useState, useEffect, useContext, useRef } from "react";
import MenuScreen from "./MenuScreen";
import LoaderScreen from "./LoaderScreen";
import { fetchContent } from "../services/api";
import AnimatedGrid from "./AnimatedGrid";
import ScreenBGItemScreen from "./ScreenBGItemScreen";
import HomeDetailsScreen from "../Module/VodDetails/VodDetailScreen";    
import ModalScreen from "./ModalScreen";
import { connect } from "react-redux";
import loginimg from "../assets/loginimg.png";
import RowList from "./RowList";
import backgroundimg from "../assets/solidbackgroundimg.png";
import logoutIcon from "../assets/Logout-Icon.png";
import ErrorScreen from "./ErrorScreen";
import errorIcon from "../assets/NoDataFound.png";
import MarkupGrid from "./MarkupGrid";
import { Translate } from "./LanguageChanger";
import LiveEventsHome from "./LiveEvents";
import AppInApp from "./AppInApp";
import $ from "jquery";
import {
  getAppInApp,
  getContinueResponse,
  getGridResponse,
  getMasterHitV2,
  getRecomendationFeed,
  getRecomendationForYou,
  getSponsorVideo,
  logoutUser,
  getActivePlan,
} from "../services/services";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";
import { AppContext } from "../AppContext";
import MyProfile from "./MyProfile";
import LiveEventDetailsScreen from "../Module/LiveEvent/LiveEventDetailsScreen";
import TvRadioDetailsScreen from "../Module/TvRadio/TvRadioDetailsScreen";
import GallaryDetailsScreen from "../Module/GallaryDetail/GallaryDetailScreen";
import { sendHomeScreenEvent } from "../Analytics/MatomoManager/homeScreenMatomo";
// import { handleViewAll } from "./dataManager";
// import SliderBanner from "./SliderBanner";
let isAppInAppOpen = false;
let resolution = window.RESOLUTION;
let numberofFocusableElemet = 3;
let defaultFocusElemntIndx = 0;
let hometags = [];
let fltrtgs = [];
let selectedTabId = -1;
// let planIds = window.PLANSIDS;
// let publisherId = window.PUBLISHERID;

const HomeScreen = ({ navigate, isLogedIn }) => {
  const [state, setState] = useState({
    isLogedInUser: false,
    loading: true,
    bannerdata: null,
    griddata: null,
    filterTags: [],
    flag: false,
    recomenddata: null,
    recomenddataFeed: null,
    shouldFocus: false,
    shouldFocusToRowList: false,
    shouldFocusToGrid: false,
    shouldFocusSlider: true,
    shouldFocusToScreenBG: false,
    shouldCloseMenu: true,
    shouldShowError: false,
    shouldAuthError: false,
    isError: false,
    errTitle: "",
    errDescription: "",
    errIcon: "",
    button: ["Logout", "Cancel"],
    
    iconWdth: "",
    iconHeight: "",
    above_recommendation: null,
    below_recommendation: null,
    shouldHideTopMenu: "flex",
    liveEventData: null,
    dsply: "none",
    zindx: "9",
    appinappData: null,
    lastFocusedElement: null,
    rememberFocusItem: null,
    lastFocusedElementRowList: null,
    sliderData: [],
  });
  const [screen, setScreen] = useState();
  const [data, setData] = useState({});
  const [rememberFocus, setRememberFocus] = useState(null);
  const [shouldShowBanner, setShouldShowBanner] = useState(true);
  const [selectedTag, setSelectedTag] = useState();
  const { sourceContext, setSourceContext } = useContext(AppContext);
  const lastSentEventRef = useRef(null);
  const [premiumQr, setPremiumQr] = useState("");
  const navigateToScreen = (screen, data = {}) => {
    if (screen === "ViewAllScreen") {
      console.log("Debug 1702 navigateToScreen ", screen);
      navigate("ViewAllScreen", data);
      return;
    }
    setScreen(screen);
    setData(data);
  };

  const handleRightButton = () => {
    console.log(
      "handleRightButton",
      shouldFocusToGrid,
      shouldFocusSlider,
      shouldFocusToRowList,
      lastFocusedElement,
      rememberFocusItem
    );
    setState((prevState) => ({
      ...prevState,
      shouldFocus: true,
      shouldFocusToGrid: lastFocusedElement === "AnimatedGrid" ? true : false,
      shouldFocusSlider: lastFocusedElement === "Slider" ? true : false,
      shouldFocusToScreenBG: false,
      shouldCloseMenu: true,
      dsply: "none,",
      shouldFocusToRowList: lastFocusedElement === "RowList" ? true : false,
      liveEventData: null,
    }));
    MenuScreen.SetFocus(true);
  };
  const {
    isLogedInUser,
    loading,
    bannerdata,
    isError,
    griddata,
    filterTags,
    recomenddata,
    shouldFocusToGrid,
    shouldFocusToRowList,
    recomenddataFeed,
    flag,
    shouldFocusToScreenBG,
    shouldCloseMenu,
    shouldShowError,
    shouldAuthError,
    errTitle,
    shouldFocus,
    errDescription,
    errIcon,
    button,
    iconWdth,
    iconHeight,
    above_recommendation,
    below_recommendation,
    shouldHideTopMenu,
    liveEventData,
    dsply,
    zindx,
    appinappData,
    shouldFocusSlider,
    lastFocusedElement,
    rememberFocusItem,
    lastFocusedElementRowList,
    sliderData,
  } = state;
  let hasFetchedData = false;
  let isGridCalled = true;

  console.log(
    "rememberFocusItem",
    rememberFocusItem,
    lastFocusedElementRowList,
    liveEventData,'screenlll', screen
  );

  useEffect(() => {
    setSourceContext("Home/Tag(0/All)");
    setSelectedTag({ id: 0, title: "All" });
    localStorage.setItem("pageName", "home");
    sendTestMatomoEvent({
      eventCategory: "Page",
      eventAction: "View",
      eventName: "Home",
      url: "home",
    });
  }, []);

  // const loadData = async () => {\
  //   if (hasFetchedData) return;
  //   hasFetchedData = true;
  //   if (!isGridCalled) return;

  // let headers = {
  //   platform: "8",
  //   iskid: "0",
  //   age: "12",
  //   country_name: "India",
  //   Langid: "1",
  //
  //   Authorization:`Bearer ${localStorage.getItem("JWTToken")}`,
  //   "Content-Type": "application/json",
  // };

  //   try {
  //     // Fetch banner and grid data simultaneously
  //     const [fetchedBannerData, fetchedGridData] = await Promise.all([
  //       fetchContent("/V1/getMasterHit", "GET", headers),
  //       fetchContent("/V1/getHomeSection", "GET", headers),
  //     ]);

  //     console.log(fetchedBannerData, fetchedGridData);

  //     isGridCalled = false;
  //     let FilteredGridData = [];
  //     for (var i = 0; i < fetchedGridData.data.length; i++) {
  //       if (
  //         fetchedGridData.data[i].list !== undefined &&
  //         fetchedGridData.data[i].list.length > 0
  //       ) {
  //         if (fetchedGridData.data[i].playlist_type !== "banner") {
  //           FilteredGridData.push(fetchedGridData.data[i]);
  //         }
  //       }
  //     }
  //     // Update state with both banner and grid data
  //     setState((prevState) => ({
  //       ...prevState,
  //       loading: false,
  //       bannerdata: fetchedBannerData.data.banners,
  //       //griddata: fetchedGridData.data,
  //       griddata: FilteredGridData,
  //     }));

  //     console.log(
  //       "fetchedBannerData",
  //       fetchedBannerData,
  //       "griddata........",
  //       griddata,
  //       "fetchedGridData.data,",
  //       fetchedGridData.data,
  //       "fetchedGridData",
  //       fetchedGridData
  //     );
  //   } catch (error) {
  // console.error("Error fetching data:", error);
  // setState((prevState) => ({
  //   ...prevState,
  //   loading: false,
  // }));
  // isGridCalled = false;
  //   }
  // };

  const exitApplication = () => {
    console.log("exitApp...");
    if (window.tizen) {
      // sendTestMatomoEvent({ action_name: `App - End`, url: "home" });
      window.tizen.application.getCurrentApplication().exit();
    } else {
      // sendTestMatomoEvent({ action_name: `App - End`, url: "home" });
      window.close();
    }
  };

  const MaterData = async () => {
    const getCountry = localStorage.getItem("country");
    let myHeaders = {
      platform: "0",
      iskid: "0",
      age: "12",
      country: getCountry,
      Langid: "1",
      lastupdated: "0000000000",
      Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      "Content-Type": "application/json",
    };

    try {
      // Fetch banner, recommendation, and grid data asynchronously
      // const [bannerResponse] = await Promise.all([
      //   fetchContent("/V1/getMasterHit", "GET", myHeaders).catch(
      //     (error) => null
      //   ),
      // ]);

      const bannerResponse = await getMasterHitV2();

      if (bannerResponse) {
        localStorage.setItem("masterData", JSON.stringify(bannerResponse));
      }

      const fetchedBannerData = bannerResponse;
      console.log(fetchedBannerData, "ShowData");
      setPremiumQr(fetchedBannerData.data.app_link.subscription_link)
      // data[currentRowIndex]?.title?.find(
      //   (item) =>
      //     item.language ==
      //     localStorage.getItem("AppLanguage")
      // )?.content ||
      //   data[currentRowIndex]?.title?.[0]?.content ||
      //   data[currentRowIndex]?.title?.[0]?.content

      //   title: fetchedBannerData.data.filterTags[i]?.title?.find((item) => item.language == localStorage.getItem("AppLanguage"))?.content,

      // Update state with the final data
      fltrtgs = [];
      let rowCounter = 0;
      for (var i = 0; i < fetchedBannerData?.data?.filterTags?.length; i++) {
        if (i == 0) {
          selectedTabId = fetchedBannerData?.data?.filterTags[i].id;
        }
        let mdl = {
          id:
            fetchedBannerData?.data?.filterTags[i]?.disableTv === 1
              ? fetchedBannerData?.data?.filterTags[i]?.id
              : "",
          setRowId:
            fetchedBannerData?.data?.filterTags[i]?.disableTv === 1
              ? rowCounter++
              : "",
          title: fetchedBannerData?.data?.filterTags[i]?.title?.find(
            (item) =>
              item.language ===
              (localStorage.getItem("AppLanguage") || "English")
          )?.content,
          // title: fetchedBannerData.data.filterTags[i]?.title?.find((item) => item.language == localStorage.getItem("AppLanguage"))?.content,
          // title: fetchedBannerData.data.filterTags[i].title[0].content,
          disableTv: fetchedBannerData.data.filterTags[i].disableTv,
          isLive : fetchedBannerData.data.filterTags[i].is_live,
        };
        fltrtgs.push(mdl);
        hometags.push(mdl.id);
        // console.log("md1.....", mdl, selectedTabId, fltrtgs);
      }

      setState((prevState) => ({
        ...prevState,
        loading: false,
        bannerdata: fetchedBannerData?.data?.banners,
        sliderData: fetchedBannerData?.data?.banners,
        filterTags: fltrtgs,
      }));
      console.log("fltrtgs", fltrtgs, rememberFocusItem);
      // if (rememberFocusItem !== null || rememberFocusItem !== undefined) {
      //   loadData(rememberFocusItem);
      // } else {
      //   loadData(fltrtgs[0].id);
      // }
      loadData(fltrtgs[0]?.id);
    } catch (error) {
      console.error("Error fetching data:", error);
      setState((prevState) => ({
        ...prevState,
        loading: false,
      }));
      isGridCalled = false;
    }
  };

  const getRandomIntInclusive = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  const loadData = async (selectedTabId) => {
    console.log("selectedTabId....", selectedTabId);
    if (selectedTabId === 12) return; // Prevent loading data for the "AppInApp" tab
    if (hasFetchedData) return; // Prevent multiple fetches
    hasFetchedData = true;

    if (!isGridCalled) return; // Ensure `isGridCalled` is true

    let user_details = null;
    try {
      user_details = JSON.parse(localStorage.getItem("user_details"));
    } catch (e) {
      console.log("Error parsing user_details", e);
    }
    const profileId = localStorage.getItem("profileId");
    const userId = localStorage.getItem("userId");

    if (isLogedIn) {
      if (!user_details || !userId || !profileId) {
        console.log("User not logged in or missing details");
        window.removeEventListener("keydown", HomeScreenKeyHandler);
        setState((prevState) => ({
          ...prevState,
          loading: true,
          shouldAuthError: true,
          shouldFocusToScreenBG: false,
          shouldFocusToRowList: false,
          shouldShowBanner: false,
          shouldFocusSlider: false,
        }));
        handleLogout();
        handleAuthFailLogout();
        
        // localStorage.removeItem("user_details");
        // localStorage.removeItem("userId");
        // localStorage.removeItem("profileId");
        // localStorage.clear();
        // window.appReload();
      }
         if (user_details && !userId && localStorage.getItem("JWTToken")&& localStorage.getItem("refresh") && !profileId ) {
          navigate("WhoWatching", {});
        }

    }

    if (isLogedIn && user_details && userId && profileId) {
      const getCountry = localStorage.getItem("country");
      let myHeaders = {
        // is_home_page: "1",
        platform: "0",
        iskid: "0",
        age: "12",
        country: getCountry,
        Langid: "1",
        lastupdated: "0000000000",
        profileid: profileId,
        Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
        "Content-Type": "application/json",
      };

      try {
        // Fetch banner, recommendation, and grid data asynchronously
        // const [
        //   // bannerResponse,
        //   getRecomendationFeed,
        //   getRecomendationForYou,
        //   gridResponse,
        //   continueResponse,
        //   AppInApp,
        //   getSponsorVideo,
        // ] = await Promise.all([
        //   // fetchContent("/V1/getMasterHit", "GET", myHeaders).catch((error) => null),
        //   fetchContent(
        //     `/V1/getHomeRecomendation/tag/` +
        //     selectedTabId +
        //     `/page/1/platform/0/userId/${userId}`,
        //     "GET",
        //     myHeaders
        //   ).catch((error) => null),
        //   fetchContent(
        //     `/V1/getRecomendationForYou/platform/0/userId/${userId}`,
        //     "GET",
        //     myHeaders
        //   ).catch((error) => null),
        //   fetchContent(
        //     "/V1/getHomeSection/0?publisher_id=0&event=" +
        //     flag +
        //     "&tag=" +
        //     selectedTabId,
        //     "GET",
        //     myHeaders
        //   ).catch((error) => null),
        //   fetchContent(
        //     `/V1/getContinueWatching/lastupdated/0000000000/platform/0/userId/${userId}`,
        //     "GET",
        //     myHeaders
        //   ).catch((error) => null),
        //   // https://sbapi.wavespb.com/api/V1/getPublisherByPlaylist?is_home_page=1&page=1&playlist_id=1
        //   fetchContent(`/V1/getPublisherByPlaylist`, "GET", myHeaders).catch(
        //     (error) => null
        //   ),
        //   fetchContent(
        //     `/V1/getSponsorVideo/0?publisher_id=0&event=false&tag=0`,
        //     "GET",
        //     myHeaders
        //   ).catch((error) => null),
        // ]);

        // console.log(
        //  getRecomendationForYou(userId, myHeaders),
        //   getRecomendationForYou,
        //   getGridResponse,
        //   getContinueResponse,
        //   "AppInApp...",
        //   getAppInApp
        // );

        // const fetchedBannerData = bannerResponse;
        const fetchedRecomendData = await getRecomendationForYou(
          userId
        );
        const fetchedRecomendFeedData = await getRecomendationFeed(
          selectedTabId,
          userId
        );
        const fetchedGridData = await getGridResponse(
          flag,
          selectedTabId,
        );
        console.log("Grid Response", fetchedGridData);
        const fetchedContinuedData = await getContinueResponse(
          userId,
        
        );
        const fetchedAppInAppData = await getAppInApp();
        const fetchedSponserVideo = await getSponsorVideo();

        //console.log("fetchedSponserVideo....", fetchedAppInAppData);

        // Filter grid data
        // const FilteredGridData = fetchedGridData.data.filter((item) => {
        //   return item.list && item.playlist_type !== "banner" && item.playlist_type !== "advertisement" && item.playlist_type !== "continue_watching" && item.playlist_type !== "popular_genres" && item.playlist_type !== "content_language" && item.layout.filter(item => item.device_type !== 8);
        //   {console.log(item.layout.filter(item => item.device_type !== 8))}
        // });

        // const FilteredGridData = fetchedGridData.data.filter((item) => {
        //   if (
        //     item.list &&
        //     item.playlist_type !== "banner" &&
        //     item.playlist_type !== "advertisement" &&
        //     item.playlist_type !== "continue_watching" &&
        //     item.playlist_type !== "popular_genres" &&
        //     item.playlist_type !== "content_language"
        //   ) {
        //     // Filter layout to exclude device_type 8
        //     const filteredLayout = item.layout.filter((layoutItem) => layoutItem.device_type !== 8);

        //     console.log(filteredLayout); // Correctly logs filtered layout

        //     return filteredLayout.length > 0; // Ensure we keep items with non-empty filtered layouts
        //   }
        //   return false;
        // });

        let FilteredGridData = [];

        if (
          fetchedGridData &&
          fetchedGridData.data &&
          fetchedGridData.data.length > 0
        ) {
          FilteredGridData = fetchedGridData.data.filter((item) => {
            // Check if 'layout' has at least one layoutItem with device_type === 8
            const hasValidDeviceType = item.layout.some(
              (layoutItem) => layoutItem.device_type === window.DEVICE_TYPE
            );
            // && item.list.some((layoutItem) => layoutItem.title !== "Photo Division" && item.list.some((layoutItem) => layoutItem.title !== "Directorate of Publications Division")));

            // console.log(item.list.some((layoutItem) => layoutItem.title === "Photo Division"))

            if (
              item.list &&
              item.playlist_type !== "banner" &&
              item.playlist_type !== "advertisement" &&
              // item.playlist_type !== "continue_watching" &&
              // item.playlist_type !== "popular_genres" &&
              // item.playlist_type !== "content_language" &&
              hasValidDeviceType // Include only if layout contains device_type: 8
            ) {
              // console.log("Valid list:", item.list); // Log the valid list
              return true; // Include this item in the filtered data
            }

            return false; // Exclude the item
          });
        }

        // Filter recommendation data
        let FilteredRecomendData = [];
        if (
          fetchedRecomendData &&
          fetchedRecomendData.data &&
          fetchedRecomendData.data.length > 0
        ) {
          FilteredRecomendData = fetchedRecomendData.data.filter((item) => {
            return item.list && item.list.length > 0;
          });
        }

        // Extract lists from the recommendation data
        let extractedListData = [];
        if (fetchedRecomendData && fetchedRecomendData.data) {
          extractedListData = fetchedRecomendData.data.flatMap(
            (item) => item.list || []
          );
        }

        // const extractedListFeedData = fetchedRecomendFeedData.data.flatMap((item) => item.list || []);

        const extractedAppInAppData = Object.values(
          fetchedAppInAppData.data
        ).reduce((acc, array) => {
          return acc.concat(
            (array || []).map((item) => ({
              ...item, // Spread existing object properties
              playlist_type: "AppInApp", // Add the new key
            }))
          );
        }, []);

        // Extract lists from the continue data
        // const extractedContinueListData = fetchedContinuedData.data.flatMap((item) => item || []);
        let extractedContinueListData = [];
        if (fetchedContinuedData && fetchedContinuedData.data) {
          extractedContinueListData = fetchedContinuedData.data
            .flatMap((item) => item || [])
            .filter(
              (item, index, self) =>
                index === self.findIndex((t) => t.show_id === item.show_id)
            );
        }

        // console.log("App in app data.....", fetchedAppInAppData);
        // const extractedAppInAppData = Object.values(AppInApp.data)
        // .flatMap((itemArray) => itemArray || [])
        // .filter(
        //   (item, index, self) =>
        //     index === self.findIndex((t) => t.id === item.id) // Use `id` instead of `show_id`
        // );

        // console.log("extractedAppInAppData.......", extractedAppInAppData);

        // Append recommendation data to the grid
        FilteredGridData.forEach((gridItem) => {
          //  console.log("gridItem...",gridItem, FilteredGridData, fetchedSponserVideo, fetchedSponserVideo.data.find(item => item.playlist_id === 98));
          //  console.log(gridItem.playlist_type_id == 4)
          if (gridItem.playlist_type === "recommendation" && gridItem.list) {
            gridItem.list = [...gridItem.list, ...(extractedListData || [])];
          }
          if (gridItem.playlist_type === "continue_watching" && gridItem.list) {
            gridItem.list = [
              ...gridItem.list,
              ...(extractedContinueListData || []),
            ];
          }
          if (gridItem.playlist_type_id === 11 && gridItem.nature === 1) {
            let data = extractedAppInAppData.filter(
              (listdata) => listdata.playlist_id === gridItem.id
            );
            //  console.log("extractedAppInAppData....5555...", data);
            gridItem.list = [...gridItem.list, ...(data || [])];
          }
          if (gridItem.playlist_type_id == 4) {
            let data = fetchedSponserVideo.data.filter(
              (item) => item.playlist_id === gridItem.id
            );

            // if (Array.isArray(gridItem.list) && Array.isArray(data[0]?.list)) {
            //   gridItem.list = [...gridItem.list, ...data[0].list];
            // }

            if (Array.isArray(data[0]?.list)) {
              gridItem.list = [...data[0].list];
            }
            // const newList = [];
            // gridItem.list = [...gridItem.list, ...(newList || [])];
            // gridItem.list = [...gridItem.list, ...(data[0] || [])];
            // console.log("gridItem.list..", gridItem.list = []);

            // const targetPlaylistIds = [98]; // IDs to update
            //   const newList = [/* new list data */]; // New list to assign

            //   fetchedSponserVideo.data.forEach(item => {
            //     if (gridItem.includes(item.playlist_id)) {
            //       item.list = data;
            //     }
            //   });
          }
        });

        // Filter out grid items with empty lists after appending data
        const FinalFilteredGridData = FilteredGridData.filter(
          (gridItem) => gridItem.list && gridItem.list.length > 0
        );

        // const Above_RecommendataionData = getRecomendationFeed.filter((gridItem) => gridItem.length);

        // const Below_RecommendataionData = getRecomendationFeed.filter((gridItem) => gridItem.length);

        // console.log(Above_RecommendataionData, Below_RecommendataionData);

        FinalFilteredGridData.forEach((item) => {
          // console.log('Above Recommendation:', item.above_recomendation);
          // console.log('Below Recommendation:', item.below_recomendation);
          // console.log("item of feed data...", item, getRecomendationFeed);
          setState((prevState) => ({
            ...prevState,
            above_recommendation: item.above_recomendation,
            below_recommendation: item.below_recomendation,
          }));
        });

        // console.log(fetchedGridData, fetchedRecomendData, FinalFilteredGridData, fetchedContinuedData, extractedContinueListData);

        // console.log("griddata....", griddata, fetchedRecomendFeedData);

        // console.log("FinalFilteredGridData...",FinalFilteredGridData);

        if (FinalFilteredGridData.length > 0) {
          let updatedGridData = [];
          for (var m = 0; m <= FinalFilteredGridData.length - 1; m++) {
            if (
              FinalFilteredGridData[m].above_recomendation !== undefined &&
              FinalFilteredGridData[m].above_recomendation > 0
            ) {
              if (fetchedRecomendFeedData?.data?.length > 0) {
                let aa = [];
                for (
                  var mm = 0;
                  mm < FinalFilteredGridData[m].above_recomendation;
                  mm++
                ) {
                  let a = getRandomIntInclusive(
                    0,
                    fetchedRecomendFeedData.data.length - 1
                  );
                  aa.push(fetchedRecomendFeedData.data[a]);
                }
                var obj = {
                  list: aa,
                  title: [],
                  playlist_type: "RecommededFeed",
                };
                updatedGridData.push(obj);
                updatedGridData.push(FinalFilteredGridData[m]);
              } else {
                updatedGridData.push(FinalFilteredGridData[m]);
              }
            } else if (
              FinalFilteredGridData[m].above_recomendation !== undefined &&
              FinalFilteredGridData[m].above_recomendation === 0 &&
              FinalFilteredGridData[m].below_recomendation !== undefined &&
              FinalFilteredGridData[m].below_recomendation > 0
            ) {
              if (fetchedRecomendFeedData?.data.length > 0) {
                let aa = [];
                for (
                  var mm = 0;
                  mm < FinalFilteredGridData[m].below_recomendation;
                  mm++
                ) {
                  let a = getRandomIntInclusive(
                    0,
                    fetchedRecomendFeedData.data.length - 1
                  );
                  aa.push(fetchedRecomendFeedData.data[a]);
                }
                var obj = {
                  list: aa,
                  title: [],
                  playlist_type: "RecommededFeed",
                };
                updatedGridData.push(FinalFilteredGridData[m]);
                updatedGridData.push(obj);
              } else {
                updatedGridData.push(FinalFilteredGridData[m]);
              }
            } else {
              updatedGridData.push(FinalFilteredGridData[m]);
            }
          }
          console.log("FinalFilteredGridData....", FinalFilteredGridData);

          // above_recommendation = [];
          // below_recommendation = [];
          // for(var i = 0; i < fetchedRecomendData.data.filterTags.length; i++){
          //   if(i == 0) {selectedTabId = fetchedBannerData.data.filterTags[i].id}
          //   let mdl = {id: fetchedBannerData.data.filterTags[i].id, title:fetchedBannerData.data.filterTags[i].title[0].content}
          //   fltrtgs.push(mdl);
          //   hometags.push(mdl.id);
          //   console.log("md1.....", mdl, selectedTabId, fltrtgs);
          // }

          // Update state with the final data
          // let fltrtgs = [];
          //   for(var i = 0; i < fetchedBannerData.data.filterTags.length; i++){
          //     let mdl = {id: fetchedBannerData.data.filterTags[i].id, title:fetchedBannerData.data.filterTags[i].title[0].content}
          //     fltrtgs.push(mdl)
          //     hometags.push(mdl.id);
          //     console.log("md1.....", mdl);
          //   }

          // setState((prevState) => {
          //   const filteredAbove = FinalFilteredGridData.filter(
          //     (item) => item.above_recommendation === 1 // Assuming 1 means true
          //   );

          //   const filteredBelow = FinalFilteredGridData.filter(
          //     (item) => item.below_recommendation === 1 // Assuming 1 means true
          //   );

          //   // Combine the filtered data or structure it however you need
          //   const structuredGridData = [...filteredAbove, ...filteredBelow];

          //   return {
          //     ...prevState,
          //     loading: false,
          //     isError: false,
          //     griddata: structuredGridData, // Use the filtered and combined data
          //     recomenddata: fetchedRecomendData,
          //     recomenddataFeed: fetchedRecomendFeedData,
          //   };
          // });
          for (let i = 0; i < updatedGridData.length; i++) {
            if (
              updatedGridData[i] &&
              updatedGridData[i].list &&
              updatedGridData[i].list.length > 0
            ) {
              updatedGridData[i].list[0].firstEntry = true;
            }
          }

          // updatedGridData = handleViewAll(updatedGridData);
          window.updatedGridData = updatedGridData;

         const bannerPlaylists = fetchedGridData.data.filter((item) => {
            return item.playlist_type_id === 2;
          });

          console.log("bannerPlaylists", bannerPlaylists);
          const fiteredDataForBanner = bannerPlaylists.map(playlist => {
              const filteredList = playlist.list.filter(item => {
                  const isExpiredTeaser = item.isTeaser === 1 && (parseInt(item.endtime) * 1000 < Date.now());
                  return !isExpiredTeaser;
              });
              return { ...playlist, list: filteredList };
          });

          console.log("fiteredDataForBanner", fiteredDataForBanner);

          setState((prevState) => ({
            ...prevState,
            loading: false,
            isError: false,
            // bannerdata: fiteredDataForBanner[0]?.list,
            // filterTags: fltrtgs, //fetchedBannerData.data.filterTags,
            sliderData: fiteredDataForBanner,
            griddata: updatedGridData, //FinalFilteredGridData,
            recomenddata: fetchedRecomendData,
            recomenddataFeed: fetchedRecomendFeedData,
          }));

          // setState((prevState) => ({
          //   ...prevState,
          //   loading: false,
          //   isError: false,
          //   // bannerdata: fetchedBannerData.data.banners,
          //   // filterTags: fltrtgs, //fetchedBannerData.data.filterTags,
          //   griddata: FinalFilteredGridData,
          //   recomenddata: fetchedRecomendData,
          //   recomenddataFeed: fetchedRecomendFeedData,
          // }));
        } else {
          setState((prevState) => ({
            ...prevState,
            griddata: [],
            loading: false,
            isError: true,
          }));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setState((prevState) => ({
          ...prevState,
          loading: false,
        }));
        isGridCalled = false;
      }

      isGridCalled = false; // Reset the grid call flag
      // loadContinueWatchingData();
    }
    // else {

    //   let myHeaders = {
    //     platform: "8",
    //     iskid: "0",
    //     age: "12",
    //     country: "India",
    //     Langid: "1",
    //
    //     "Content-Type": "application/json",
    //   };

    //   try {
    //     // Fetch banner, recommendation, and grid data asynchronously
    //     const [bannerResponse, gridResponse] = await Promise.all([
    //       fetchContent("/V1/getMasterHit", "GET", myHeaders),
    //       fetchContent("/V1/getHomeSection/8?publisher_id=0&event=false&tag=" + selectedTabId, "GET", myHeaders)
    //     ]);

    //     // Check if the responses are okay
    //     // if (!bannerResponse.ok || !gridResponse.ok) {
    //     //   throw new Error("One or more APIs failed");
    //     // }

    //     const fetchedBannerData = bannerResponse;
    //     const fetchedGridData = gridResponse;

    //     // Filter grid data
    //     const FilteredGridData = fetchedGridData.data.filter((item) => {
    //       return item.list && item.list.length > 0 && item.playlist_type !== "banner" && item.playlist_type !== "advertisement" && item.playlist_type !== "recommendation" && item.playlist_type !== "continue_watching";
    //     });

    //     // console.log(fetchedBannerData, fetchedGridData);

    //     // Update state with the final data
    //     // for(i=  )
    //     setState((prevState) => ({
    //       ...prevState,
    //       loading: false,
    //       bannerdata: fetchedBannerData.data.banners,
    //       filterTags: fetchedBannerData.data.filterTags,
    //       griddata: FilteredGridData,
    //     }));

    //   } catch (error) {
    //     console.error("Error fetching data:", error);
    //     setState((prevState) => ({
    //       ...prevState,
    //       loading: false,
    //     }));
    //     isGridCalled = false;
    //   }

    //   isGridCalled = false;
    // }
    else {
      const user_details = JSON.parse(localStorage.getItem("user_details"));
      const getCountry = localStorage.getItem("country");

      // const userId = localStorage.getItem("profileId");
      // console.log(user_details, user_details["user_profiles"][0]["profile_id"]);

      let myHeaders = {
        platform: "0",
        iskid: "0",
        age: "12",
        country: getCountry,
        Langid: "1",
        lastupdated: "0000000000",
        profileid: null,
        // Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
        "Content-Type": "application/json",
      };

      try {
        // Fetch banner, recommendation, and grid data asynchronously
        // const [
        //   // bannerResponse,
        //   getRecomendationFeed,
        //   // getRecomendationForYou,
        //   gridResponse,
        //   AppInApp,
        //   getSponsorVideo,
        // ] = await Promise.all([
        //   // fetchContent("/V1/getMasterHit", "GET", myHeaders).catch((error) => null),
        //   fetchContent(
        //     `/V1/getHomeRecomendation/tag/` +
        //     selectedTabId +
        //     `/page/1/platform/0/userId/${null}`,
        //     "GET",
        //     myHeaders
        //   ).catch((error) => null),
        //   // fetchContent(`/V1/getRecomendationForYou/platform/0/userId/${userId}`, "GET", myHeaders).catch((error) => null),
        //   fetchContent(
        //     "/V1/getHomeSection/8?publisher_id=0&event=" +
        //     flag +
        //     "&tag=" +
        //     selectedTabId,
        //     "GET",
        //     myHeaders
        //   ).catch((error) => null),
        //   // fetchContent(`/V1/getContinueWatching/lastupdated/0000000000/platform/0/userId/${userId}`, "GET", myHeaders).catch((error) => null),
        //   // https://sbapi.wavespb.com/api/V1/getPublisherByPlaylist?is_home_page=1&page=1&playlist_id=1
        //   fetchContent(`/V1/getPublisherByPlaylist`, "GET", myHeaders).catch(
        //     (error) => null
        //   ),
        //   fetchContent(
        //     `/V1/getSponsorVideo/0?publisher_id=0&event=false&tag=0`,
        //     "GET",
        //     myHeaders
        //   ).catch((error) => null),
        // ]);

        // const fetchedBannerData = bannerResponse;
        // const fetchedRecomendData = getRecomendationForYou;
        const fetchedRecomendFeedData = await getRecomendationFeed(
          selectedTabId,
          userId,
         
        );
        const fetchedGridData = await getGridResponse(
          flag,
          selectedTabId,
       
        );
        console.log("Grid Response", fetchedGridData);
        const fetchedSponserVideo = await getSponsorVideo();
        // const fetchedContinuedData = continueResponse;
        const fetchedAppInAppData = await getAppInApp();

        // Filter grid data
        // const FilteredGridData = fetchedGridData.data.filter((item) => {
        //   return item.list && item.playlist_type !== "banner" && item.playlist_type !== "advertisement";
        // });

        const FilteredGridData = fetchedGridData.data.filter((item) => {
          // console.log("item.....", item);

          // Check if 'layout' has at least one layoutItem with device_type === 8
          const hasValidDeviceType = item.layout.some(
            (layoutItem) => layoutItem.device_type === window.DEVICE_TYPE,
          );

          if (
            item.list &&
            item.playlist_type !== "banner" &&
            item.playlist_type !== "advertisement" &&
            item.playlist_type !== "continue_watching" &&
            // item.playlist_type !== "popular_genres" &&
            // item.playlist_type !== "content_language" &&
            hasValidDeviceType // Include only if layout contains device_type: 8
          ) {
            // console.log("Valid list:", item.list); // Log the valid list
            return true; // Include this item in the filtered data
          }

          return false; // Exclude the item
        });

        // console.log("App in app data.....", fetchedAppInAppData);
        const extractedAppInAppData = Object.values(fetchedAppInAppData.data)
          .flatMap((itemArray) => itemArray || [])
          .filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.id === item.id) // Use `id` instead of `show_id`
          );

        FilteredGridData.forEach((gridItem) => {
          if (gridItem.playlist_type_id === 11 && gridItem.nature === 1) {
            let data = extractedAppInAppData.filter(
              (listdata) => listdata.playlist_id === gridItem.id
            );
            gridItem.list = [...gridItem.list, ...(data || [])];
          }
          if (gridItem.playlist_type_id == 4) {
            //console.log("szdfsdfsdf", gridItem.playlist_type_id == 4);
            //console.log("fetchedSponserVideo....5555...");
            let data = fetchedSponserVideo.data.filter(
              (item) => item.playlist_id === gridItem.id
            );
            // console.log("data....", data);

            // if (Array.isArray(gridItem.list) && Array.isArray(data[0]?.list)) {
            //   gridItem.list = [...gridItem.list, ...data[0].list];
            // }

            if (Array.isArray(data[0]?.list)) {
              gridItem.list = [...data[0].list];
            }
            // const newList = [];
            // gridItem.list = [...gridItem.list, ...(newList || [])];
            // gridItem.list = [...gridItem.list, ...(data[0] || [])];
            // console.log("gridItem.list..", gridItem.list = []);

            // const targetPlaylistIds = [98]; // IDs to update
            //   const newList = [/* new list data */]; // New list to assign

            //   fetchedSponserVideo.data.forEach(item => {
            //     if (gridItem.includes(item.playlist_id)) {
            //       item.list = data;
            //     }
            //   });
          }
        });

        // Filter recommendation data
        // const FilteredRecomendData = fetchedRecomendData.data.filter((item) => {
        //   return item.list && item.list.length > 0;
        // });

        // Extract lists from the recommendation data
        // const extractedListData = fetchedRecomendData.data.flatMap((item) => item.list || []);

        const extractedListFeedData = fetchedRecomendFeedData?.data.flatMap(
          (item) => item.list || []
        );

        // Extract lists from the continue data
        // const extractedContinueListData = fetchedContinuedData.data.flatMap((item) => item || []);

        // console.log("getRecomendationFeed....", getRecomendationFeed);

        // Filter out grid items with empty lists after appending data
        const FinalFilteredGridData = FilteredGridData.filter(
          (gridItem) => gridItem.list && gridItem.list.length > 0
        );

        console.log("FinalFilteredGridData....", fetchedGridData.data);

        FinalFilteredGridData?.forEach((item) => {
          setState((prevState) => ({
            ...prevState,
            above_recommendation: item.above_recomendation,
            below_recommendation: item.below_recomendation,
          }));
        });

        // console.log(fetchedGridData, FinalFilteredGridData);

        // console.log("griddata....", griddata, fetchedRecomendFeedData);

        // console.log("FinalFilteredGridData...",FinalFilteredGridData);

        if (FinalFilteredGridData.length > 0) {
          let updatedGridData = [];
          let nextPageData = [];
          for (var m = 0; m <= FinalFilteredGridData.length - 1; m++) {
            if (
              FinalFilteredGridData[m].above_recomendation !== undefined &&
              FinalFilteredGridData[m].above_recomendation > 0
            ) {
              if (fetchedRecomendFeedData?.data.length > 0) {
                let aa = [];
                for (
                  var mm = 0;
                  mm < FinalFilteredGridData[m].above_recomendation;
                  mm++
                ) {
                  let a = getRandomIntInclusive(
                    0,
                    fetchedRecomendFeedData.data.length - 1
                  );
                  aa.push(fetchedRecomendFeedData.data[a]);
                }
                var obj = {
                  list: aa,
                  title: [],
                  playlist_type: "RecommededFeed",
                };
                updatedGridData.push(obj);
                updatedGridData.push(FinalFilteredGridData[m]);
              } else {
                updatedGridData.push(FinalFilteredGridData[m]);
              }
            } else if (
              FinalFilteredGridData[m].above_recomendation !== undefined &&
              FinalFilteredGridData[m].above_recomendation === 0 &&
              FinalFilteredGridData[m].below_recomendation !== undefined &&
              FinalFilteredGridData[m].below_recomendation > 0
            ) {
              if (fetchedRecomendFeedData?.data.length > 0) {
                let aa = [];
                for (
                  var mm = 0;
                  mm < FinalFilteredGridData[m].above_recomendation;
                  mm++
                ) {
                  let a = getRandomIntInclusive(
                    0,
                    fetchedRecomendFeedData.data.length - 1
                  );
                  aa.push(fetchedRecomendFeedData.data[a]);
                }
                var obj = {
                  list: aa,
                  title: [],
                  playlist_type: "RecommededFeed",
                };
                updatedGridData.push(FinalFilteredGridData[m]);
                updatedGridData.push(obj);
              } else {
                updatedGridData.push(FinalFilteredGridData[m]);
              }
            } else {
              updatedGridData.push(FinalFilteredGridData[m]);
            }
          }
          // console.log(FinalFilteredGridData.above_recommendation, FinalFilteredGridData.below_recommendation);

          // above_recommendation = [];
          // below_recommendation = [];
          // for(var i = 0; i < fetchedRecomendData.data.filterTags.length; i++){
          //   if(i == 0) {selectedTabId = fetchedBannerData.data.filterTags[i].id}
          //   let mdl = {id: fetchedBannerData.data.filterTags[i].id, title:fetchedBannerData.data.filterTags[i].title[0].content}
          //   fltrtgs.push(mdl);
          //   hometags.push(mdl.id);
          //   console.log("md1.....", mdl, selectedTabId, fltrtgs);
          // }

          // Update state with the final data
          // let fltrtgs = [];
          //   for(var i = 0; i < fetchedBannerData.data.filterTags.length; i++){
          //     let mdl = {id: fetchedBannerData.data.filterTags[i].id, title:fetchedBannerData.data.filterTags[i].title[0].content}
          //     fltrtgs.push(mdl)
          //     hometags.push(mdl.id);
          //     console.log("md1.....", mdl);
          //   }

          // setState((prevState) => {
          //   const filteredAbove = FinalFilteredGridData.filter(
          //     (item) => item.above_recommendation === 1 // Assuming 1 means true
          //   );

          //   const filteredBelow = FinalFilteredGridData.filter(
          //     (item) => item.below_recommendation === 1 // Assuming 1 means true
          //   );

          //   // Combine the filtered data or structure it however you need
          //   const structuredGridData = [...filteredAbove, ...filteredBelow];

          //   return {
          //     ...prevState,
          //     loading: false,
          //     isError: false,
          //     griddata: structuredGridData, // Use the filtered and combined data
          //     recomenddata: fetchedRecomendData,
          //     recomenddataFeed: fetchedRecomendFeedData,
          //   };
          // });

          // updatedGridData = handleViewAll(updatedGridData);
          // nextPageData = await PaginationData(updatedGridData);

          for (let i = 0; i < updatedGridData.length; i++) {
            if (
              updatedGridData[i] &&
              updatedGridData[i].list &&
              updatedGridData[i].list.length > 0
            ) {
              updatedGridData[i].list[0].firstEntry = true;
            }
          }
          window.updatedGridData = updatedGridData;
          // window.nextPageData = nextPageData;
          // console.log("nextPageData....", nextPageData);

          // if (nextPageData && Array.isArray(nextPageData)) {
          //   updatedGridData = handleViewAll([...nextPageData]);
          //   console.log("updatedGridData....", updatedGridData);
          // } else {
          //   updatedGridData = handleViewAll(updatedGridData);
          // }

          const bannerPlaylists = fetchedGridData.data.filter((item) => {
            return item.playlist_type_id === 2;
          });

          const fiteredDataForBanner = bannerPlaylists.map(playlist => {
              const filteredList = playlist.list.filter(item => {
                  const isExpiredTeaser = item.isTeaser === 1 && (parseInt(item.starttime) * 1000 < Date.now());
                  return !isExpiredTeaser;
              });
              return { ...playlist, list: filteredList };
          });
          console.log("fiteredDataForBanner", fiteredDataForBanner);

          setState((prevState) => ({
            ...prevState,
            loading: false,
            isError: false,
            // bannerdata: fiteredDataForBanner[0]?.list,
            // filterTags: fltrtgs, //fetchedBannerData.data.filterTags,
            sliderData: fiteredDataForBanner,
            griddata: updatedGridData, //FinalFilteredGridData,
            // recomenddata: fetchedRecomendData,
            recomenddataFeed: fetchedRecomendFeedData,
          }));

          // setState((prevState) => ({
          //   ...prevState,
          //   loading: false,
          //   isError: false,
          //   // bannerdata: fetchedBannerData.data.banners,
          //   // filterTags: fltrtgs, //fetchedBannerData.data.filterTags,
          //   griddata: FinalFilteredGridData,
          //   recomenddata: fetchedRecomendData,
          //   recomenddataFeed: fetchedRecomendFeedData,
          // }));
        } else {
          setState((prevState) => ({
            ...prevState,
            griddata: [],
            loading: false,
            isError: true,
          }));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setState((prevState) => ({
          ...prevState,
          loading: false,
        }));
        isGridCalled = false;
      }

      isGridCalled = false; // Reset the grid call flag
      // loadContinueWatchingData();
    }
  };

  const handleAuthFailLogout = async (p) => {
    // console.log("handleAuthFailLogout......", window.APIENDPOINT,localStorage.getItem("myProfile"))
      const userDetails = JSON.parse(localStorage.getItem("user_details") || "{}");

    // if (userDetails) {
    //   await sendTestMatomoEvent({
    //     eventCategory: "SessionTimedOut",
    //     eventAction: "Logout",
    //     eventName: window.APIENDPOINT,
    //   });
    // }

    setState((prevState) => ({
      ...prevState,
      shouldFocusToGrid: false,
      shouldCloseMenu: true,
      shouldAuthError: true,
      shouldShowModal: false,
      shouldShowAuthModal: true,
      shouldAddEventListener: false,
      // errTitle: "Session-Expired",
      errDescription: "session-desc",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Login"],
    }));
    MenuScreen.SetFocus(true);
  };

  const getActivePlans = async () => {
    console.log("getactiveplan....");
    const userId = localStorage.getItem("profileId")
      ? localStorage.getItem("profileId")
      : null;
    const publisherId = 0;

    try {
      // Fetch banner and grid data simultaneously
      // const response = await fetchContent("/V1/getCountryByCDN", "GET");

      const response = await getActivePlan(userId, publisherId);
      console.log("getactiveplan....", response);
      if (response.statusCode === 401) {
        console.log("master Data.getActivePlans...", response);
        setState((prevState) => ({
          ...prevState,
          loading: false,
          shouldAuthError: true,
        }));
        handleAuthFailLogout();
        return;
      }
      if (
        response?.data?.publishers &&
        Array.isArray(response.data.publishers)
      ) {
        const publishers = response.data.publishers;
        const plans = response.data.pubtxn.length > 0;

        // Detect if elements are objects with `pricing_id`, or just IDs
        const hasPricingObjects = publishers.length > 0;

        let pricingIds = [];
        let publisherList = [];

        const features = response?.data?.plan?.features;

        const result = features.find(
          (item) => item.type == "5"
        );

        console.log("getplanprice....", result);

        window.IS_DISPLAY = result.value;

        if (hasPricingObjects || plans) {
          pricingIds =
            response?.data?.pubtxn?.map((item) => item.pricing_id) || [];
          // publisherList = publishers.map(item => ({ publisherId: item.publisher_id }));
          publisherList = response.data.publishers.map((id) => {
            return { publisherId: id };
          });
        } else {
          // If publishers is an array of IDs
          publisherList = publishers.map((id) => ({ publisherId: id }));
        }

        // Set global variables safely
        window.PLANSIDS = pricingIds;
        window.PUBLISHERID = publisherList;

        console.log("PLANSIDS:", window.PLANSIDS);
        console.log("PUBLISHERID:", window.PUBLISHERID);
      }

      // if (response?.data !== undefined && response?.data !== null) {
      //   const pricingIds = response?.data?.publishers.map(item => item.pricing_id);
      //   planIds = pricingIds;
      //   window.PLANSIDS = planIds;
      // const publisherList = response.data.publishers.map((id) => {
      //   return { publisherId: id };
      // });
      //   publisherId = publisherList;
      //   window.PUBLISHERID = publisherId;
      //   console.log("pricingIds...", publisherId, publisherList);
      // }
      // localStorage.setItem("country", response?.data?.country);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const chageAppInAppStatus = (p) => {
    console.log("p....", p);
    isAppInAppOpen = p;
  };

  const modalOKButtonHandler = async (action) => {
    let Logout = action?.props?.langKey;
    console.log(action, "action in modalOKButtonHandler");

    switch (Logout ? Logout : action) {
      case "Login":
        const myProfile = localStorage.getItem("myProfile");
        // await sendTestMatomoEvent({
        //   eventCategory: "Page",
        //   eventAction: "View",
        //   eventName: "LoginPopup",
        //   url: "Home",
        // });
        localStorage.removeItem("user_details");
        localStorage.removeItem("userId");
        localStorage.removeItem("profileId");
        localStorage.clear();
        window.appReload();
        navigate("LoginScreen");
        break;

      case "Logout":
        logoutUser();
        localStorage.removeItem("JWTToken");
        localStorage.removeItem("userInfo");
        // const getCountry = localStorage.getItem("country");
        // let headers = {
        //   iskid: "0",
        //   Langid: "1",
        //   "Content-Type": "application/json",
        //   country: getCountry,
        // };
        // Promise.all([fetchContent("/V1/logout", "POST", headers)]);
        // console.log("Logout", Promise.all([fetchContent("/V1/logout", "POST", headers)]))

        localStorage.clear();
        window.appReload();
        MenuScreen.ReseTfocus(4);
        MenuScreen.SetFocus(true);
        handleMenuselection("Login");
        break;
      case "Exit":
        exitApplication();
        // window.close();
        // navigate("LoginScreen");
        break;
      default:
        break;
    }
  };

  console.log("griddata.....", griddata);

  // const modalOKButtonHandler = (action) => {
  //   // console.log("modalOKButtonHandler....");
  //   switch (action) {
  //     case "Login":
  //       navigate("LoginScreen");
  //       break;
  //     case "Logout":
  //       localStorage.removeItem("JWTToken");
  //       localStorage.removeItem("userInfo");
  //       let headers = {
  //         iskid: "0",
  //         Langid: "1",
  //         "Content-Type": "application/json",
  //         country: "india",
  //       };
  //       // Promise.all([fetchContent("/V1/logout", "POST", headers)]);
  //       MenuScreen.ReseTfocus(4);
  //       MenuScreen.SetFocus(true);
  //       handleMenuselection("Login");
  //       break;
  //     case "Exit":
  //       console.log("exit application..");
  //       exitApplication();
  //       // window.close();
  //       // navigate("LoginScreen");
  //       break;
  //     default:
  //       break;
  //   }
  // };
  const modalCANCELButtonHandler = () => {
    let eventCategory = "Page";
    let eventAction = "View";
    let eventName = "CancelPopup";
    // sendTestMatomoEvent({
    //   eventCategory,
    //   eventAction,
    //   eventName,
    //   url: "Home",
    // });
    MenuScreen.ReseTfocus(5);
    // MenuScreen.ReseTfocus(-1);
    setState((prevState) => ({
      ...prevState,
      shouldShowError: false,
      shouldFocusToGrid: shouldFocusSlider !== true ? true : false,
      shouldFocusSlider: true,
    }));
  };

  const callBack = (screenname, isBack = false, isLiveEvent = false) => {
    console.log(
      "callBack HomeScreen.js -------1221------------",
      screenname,
      isBack,
      isLiveEvent,
      shouldFocusSlider,
      shouldFocusToGrid,
      shouldFocusToRowList
    );
    if (!isBack && !isLiveEvent) {
      console.log(
        "callBack HomeScreen.js -------------------",
        shouldFocusSlider,
        shouldFocusToGrid,
        shouldFocusToRowList
      );
      setState((prevState) => ({
        ...prevState,
        shouldFocusToGrid: false,
        shouldShowModal: false,
        shouldFocusSlider: true,
      }));
      AnimatedGrid.setFocus(true);
    } else if (isBack && !isLiveEvent) {
      console.log(
        "callBack HomeScreen.js -------111------------",
        shouldFocusSlider,
        shouldFocusToGrid,
        shouldFocusToRowList,
        lastFocusedElement
      );
      setState((prevState) => ({
        ...prevState,
        lastFocusedElement: shouldFocusSlider
          ? "Slider"
          : shouldFocusToRowList
          ? "RowList"
          : "AnimatedGrid",
      }));
      setState((prevState) => ({
        ...prevState,
        shouldFocusToGrid: false,
        shouldFocusToScreenBG: false,
        shouldCloseMenu: false,
        shouldShowModal: false,
        shouldFocusSlider: false,
      }));
      //  console.log("is back trueeeeeeeeeee -----------------------");
      MenuScreen.SetFocus(false);
    } else if (isBack && isLiveEvent) {
      console.log(
        "callBack HomeScreen.js -------222------------",
        shouldFocusSlider,
        shouldFocusToGrid,
        shouldFocusToRowList,
        lastFocusedElement
      );
      navigateToScreen("");
    }
  };

  const HomeScreenKeyHandler = (event) => {
    //   console.log("HomeScreenKeyHandler -----event = ", event.keyCode);
    if (event.keyCode !== undefined) {
      switch (event.keyCode) {
        case 13:
          // MaterData();
          break;
        case 39:
          break;
        case 37:
          break;
        default:
          break;
      }
    }
  };

  useEffect(() => {
    console.log(
      "HomeScreen.js useEffect 1st time -------------------",
      rememberFocusItem,
      lastFocusedElement,
      shouldFocusSlider,
      shouldFocusToGrid,
      shouldFocusToRowList
    );
    MenuScreen.ReseTfocus(5);
    MaterData();
    // if (isLogedIn) {
    getActivePlans();
    // }
    // loadData();
    // loadContinueWatchingData();
    //window.addEventListener('keydown', HomeScreenKeyHandler);
    return () => {
      //window.removeEventListener('keydown', HomeScreenKeyHandler);
    };
  }, [liveEventData]);

  useEffect(() => {
    if (window.appinappDataResponse) {
      setState((prevState) => ({
        ...prevState,
        appinappData: window.appinappDataResponse,
      }));
    }
    if (window.updatedGridData) {
      setState((prevState) => ({
        ...prevState,
        griddata: window.updatedGridData,
      }));
    }
    if (window.clearTime) {
      clearInterval(window.clearTime);
    }
  }, [loading]);

  const styles = {
    homeScreenContainer: {
      display: "flex",
      flexDirection: "row",
      height: "100vh",
      width: "100vw",
      color: "#333",
      fontSize: "1.5em",
      // background: "#0E1653",
      background: `url(${backgroundimg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      overflow: "hidden",
      position: "absolute",
    },
  };

  const FocusHandler = (componentName, data = []) => {
    if (componentName === "ScreenBGItemScreen") {
      setState((prevState) => ({
        ...prevState,
        shouldFocusToGrid: true,
      }));
      //ScreenBGItemScreen.setFocus(true);
    } else if (componentName === "AnimatedGrid") {
      setState((prevState) => ({
        ...prevState,
        shouldFocusToGrid: true,
        shouldFocusSlider: false,
        shouldFocusToRowList: false,
        shouldFocus: false,
      }));
    } else if (componentName === "RowList") {
      setState((prevState) => ({
        ...prevState,
        shouldFocusToGrid: false,
        shouldFocus: true,
        shouldFocusToRowList: true,
        shouldFocusSlider: false,
      }));
    } else if (componentName === "Slider") {
      setState((prevState) => ({
        ...prevState,
        shouldFocusToGrid: false,
        shouldFocus: false,
        shouldFocusToRowList: false,
        shouldFocusSlider: true,
      }));
    } else if (componentName === "LiveEvent") {
      console.log("data...", data);
      setState((prevState) => ({
        ...prevState,
        dsply: "flex",
        liveEventData: data,
        zindx: "0",
        shouldFocus: false,
        shouldFocusToGrid: false,
        shouldFocusToRowList: false,
      }));
    } else if (componentName === "LiveEventBackKey") {
      setShouldShowBanner(true);
      setState((prevState) => ({
        ...prevState,
        dsply: "none",
        zindx: "9",
        liveEventData: null,
        shouldFocusToRowList: true,
        shouldFocus: false,
        shouldFocusToGrid: false,
        shouldCloseMenu: true,
        rememberFocusItem: 0,
      }));
      loadData(fltrtgs[0].id);
      MenuScreen.SetFocus(true);
      // AnimatedGrid.clearCurrentKeyListener();
    } else if (componentName === "appinapp") {
      console.log("appinapp....", componentName, data);
      isAppInAppOpen = false;
      setState((prevState) => ({
        ...prevState,
        dsply: "none",
        zindx: "9",
        shouldHideTopMenu: false,
      }));
    }
  };

  const handleBack = (screenName) => {
    console.log(
      "handleBack HomeScreen.js -------------------",
      lastFocusedElement,
      shouldFocusSlider,
      shouldFocusToGrid,
      shouldFocusToRowList,
      lastFocusedElementRowList
    );
    if (liveEventData && liveEventData.length > 0 && dsply === "flex") {
      console.log(
        "handleBack HomeScreen.js -------111------------",
        shouldFocusSlider,
        shouldFocusToGrid,
        shouldFocusToRowList,
        lastFocusedElement
      );
      console.log("videoLanguage", window.videoLanguage, liveEventData);
      console.log("videoSettings", window.videoSettings, liveEventData);
      if (window.videoLanguage === true || window.videoSettings === true) {
        window.videoLanguage = false;
        window.videoSettings = false;
        console.log(
          "videoLanguage or videoSettings is true, returning without setting screen"
        );
      } else {
        console.log(window.videoLanguage, window.videoSettings);
        setScreen(screenName);
        // window.videoLanguage = true;
        // window.videoSettings = true;
      }
    } else {
      console.log(
        "handleBack HomeScreen.js -------222------------",
        shouldFocusSlider,
        shouldFocusToGrid,
        shouldFocusToRowList,
        lastFocusedElement
      );

      // setState((prevState) => ({
      //   ...prevState,
      //   lastFocusedElement:shouldFocusSlider ? "Slider" : shouldFocusToRowList ? "RowList" : "AnimatedGrid",
      // }));

      // setState((prevState) => ({
      //   ...prevState,
      //   // shouldFocusToGrid: false,
      //   shouldShowModal:false,
      //   // shouldFocusSlider:true,
      //   shouldFocusToGrid: lastFocusedElement === "AnimatedGrid" ? true : false,
      //   shouldFocusSlider: lastFocusedElement === "Slider" ? true : false,
      //   shouldFocusToScreenBG: false,
      //   shouldCloseMenu: true,
      //   dsply: "none,",
      //   shouldFocusToRowList: lastFocusedElement === "RowList" ? true : false,
      // }));

      setState((prevState) => {
        // Determine the new lastFocusedElement first
        const newLastFocusedElement = shouldFocusSlider
          ? "Slider"
          : shouldFocusToRowList
          ? "RowList"
          : "AnimatedGrid";

        return {
          ...prevState,
          // Update lastFocusedElement
          lastFocusedElement: newLastFocusedElement,

          // Update other state properties based on the new lastFocusedElement
          shouldShowModal: false,
          shouldFocusToGrid: newLastFocusedElement === "AnimatedGrid",
          shouldFocusSlider: newLastFocusedElement === "Slider",
          shouldFocusToScreenBG: false,
          shouldCloseMenu: true,
          dsply: "none",
          shouldFocusToRowList: newLastFocusedElement === "RowList",
        };
      });
      setScreen(screenName);
      console.log("isAppInAppOpen ------- = ", isAppInAppOpen);
      if (isAppInAppOpen) {
        //  let tmr = setTimeout(function(){clearTimeout(tmr);AnimatedGrid.onOKPress()}, 5000);
      }
    }
  };

  // let logout = <Translate langKey={"Logout"} />;
  // let logoutDes = <Translate langKey={"cofirm-logout"} />;
  // let caencel = <Translate langKey={"Cancel"} />;

  const handleLogout = (p) => {
    setState((prevState) => ({
      ...prevState,
      shouldFocusToRowList: false,
      shouldCloseMenu: true,
      shouldShowError: true,
      errTitle: "Logout",
      errDescription: "cofirm-logout",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Logout", "Cancel"],
    }));
    MenuScreen.SetFocus(true);

    if (!shouldAuthError) {
      sendTestMatomoEvent({
        eventCategory: "MyProfile",
        // eventAction: "Logout",
      });
    }
  };

  const handleLogin = (p) => {
    // console.log("homescreen....", shouldShowError);
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
      shouldShowError: true,
      errTitle: "Login to Continue",
      errDescription: "LoginContinue",
      errIcon: loginimg,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Login", "Cancel"],
    }));
    MenuScreen.SetFocus(true);
  };

  const handleExit = () => {
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
      shouldShowError: true,
      errTitle: "Exit",
      errDescription: "ExitMsg",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Exit", "Cancel"],
    }));
    MenuScreen.SetFocus(true);
  };

  const RowlListcallBack = (SeletedItem) => {
    console.log(
      "RowlListcallBack....",
      SeletedItem,
      selectedTabId,
      shouldFocusToRowList,
      shouldFocusToGrid,
      lastFocusedElementRowList
    );

    const eventKey = `Tag(${SeletedItem.id}/${SeletedItem.title})`;
    if (lastSentEventRef.current !== eventKey) {
      sendHomeScreenEvent(
        eventKey
      );
      lastSentEventRef.current = eventKey;
    }

    setState((prevState) => ({
      ...prevState,
      loading: true,
      // flag:true,
      // griddata:[null],
      // selectedTabId: SeletedItem.id,
      shouldCloseMenu: false,
      // shouldFocusToRowList: true,
      shouldFocusToGrid: false,
      shouldShowModal: false,
      shouldFocusToRowList: true,
      lastFocusedElementRowList: shouldFocusSlider
        ? "Slider"
        : shouldFocusToRowList
        ? "RowList"
        : "AnimatedGrid",
      rememberFocusItem: SeletedItem.setRowId,
    }));
    // hereCode selectedTag
    // console.log("selectedTagInfo", SeletedItem);
    // Setup the source context tag
    setSourceContext(`Home/Tag(${SeletedItem.id}/${SeletedItem.title})`);
    setSelectedTag(SeletedItem);
    // console.log("selectedTagInfo", selectedTag);

    if (SeletedItem.id === 0) {
      setShouldShowBanner(true);
    } else {
      setShouldShowBanner(false);
    }
    loadData(SeletedItem.id);
    AnimatedGrid.setFocusDefault();
    // console.log("selectedTabId....", selectedTabId);
  };

  const handleLeftButton = () => {
    console.log(
      "handleLeftButton   ---- = ",
      shouldFocusToRowList,
      shouldFocusToGrid,
      shouldFocusSlider
    );
    setState((prevState) => ({
      ...prevState,
      shouldFocus: true,
      shouldFocusToRowList: false,
      shouldFocusToGrid: false,
      shouldCloseMenu: false,
    }));
    MenuScreen.SetFocus(false);
  };

  const handleBackButton = () => {
    console.log("handleBackButton   ---- = ");
    setState((prevState) => ({
      ...prevState,
      lastFocusedElement: shouldFocusSlider
        ? "Slider"
        : shouldFocusToRowList
        ? "RowList"
        : "AnimatedGrid",
    }));
    setState((prevState) => ({
      ...prevState,
      shouldFocus: false,
      shouldFocusToRowList: false,
      shouldFocusToGrid: false,
      shouldCloseMenu: false,
      shouldShowModal: false,
    }));
    MenuScreen.SetFocus(false);
  };

  const handleRowListDownButton = () => {
    // console.log("handleRowListDownButton....", shouldFocusToRowList, shouldFocusToGrid);
    setTimeout(() => {
      AnimatedGrid.setFocusDefault();
      setState((prevState) => ({
        ...prevState,
        shouldFocus: false,
        shouldFocusToRowList: false,
        // shouldFocusToGrid: true,
        shouldFocusToScreenBG: false,
        shouldFocusSlider: shouldShowBanner ? true : false,
        shouldFocusToGrid: shouldShowBanner ? false : true,
      }));
    }, 200);
  };

  const handleRowListUpButton = () => {
    // console.log("handleRowListUpButton -----------------");
    // if (shouldFocusToSeasonRowList) {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        // shouldFocusToRowList: true,
        // shouldFocusToGrid: false,
        shouldFocus: true,
        shouldFocusToGrid: false,
        shouldFocusToScreenBG: false,
      }));
    }, 200);
  };

  // console.log("recomenddataFeed....", recomenddataFeed);
  const Home_Navigate = (p) => {
    console.log(
      "Home_Navigate....",
      p,
      shouldFocusSlider,
      shouldFocusToRowList,
      shouldFocusToGrid,
      lastFocusedElement
    );
    isGridCalled = false;
    setState((prevState) => ({
      ...prevState,
      shouldHideTopMenu: "flex",
      shouldFocusToGrid: true,
      shouldFocus: true,
      shouldFocusToRowList: false,
      shouldShowModal: false,
    }));
    AnimatedGrid.clearCurrentKeyListener();
    AnimatedGrid.setFocus();

    // setState((prevState) => ({
    //   ...prevState,
    //   loading: false,
    //   shouldFocusToGrid: true
    // }));
    //navigate(p);
  };

  const HideRowList = () => {
    setState((prevState) => ({
      ...prevState,
      shouldHideTopMenu: "none",
      shouldFocus: false,
      shouldFocusToGrid: false,
    }));
  };

  const handleMenuselection = (selectedMenu) => {
    switch (selectedMenu) {
      case "Login":
        navigate("LoginScreen");
        break;
      case "Profile":
        navigate("ProfileScreen");
        break;
      case "Search":
        navigate("SearchScreen");
        break;
      case "Live":
        navigate("LiveScreen");
        break;
      case "LiveEvents":
        navigate("LiveEventsScreen");
        break;
      case "Home":
        navigate("HomePage");
        break;
      case "Watchlist":
        break;
      case "Categories":
        navigate("CategoryScreen");
        break;
      case "Settings":
        navigate("SettingsScreen");
        break;
      case "Logout":
        break;
      default:
        break;
    }
  };

  const detailToDetail = (recommendationItem) => {
    console.log("naveen :: detailToDetail", recommendationItem);
    // setData(recommendationItem);
    // setScreen("DetailsScreen")
    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));
    const VOD = recommendationItem?.type == 0
    const AOD = recommendationItem?.type === 1 || recommendationItem?.media_type === 1
    const AudioLiveTv = recommendationItem?.type == 1 && recommendationItem?.still_live == 1
    const LiveTV = recommendationItem.type === 0 && recommendationItem.still_live === 1;
    const LiveEvent = recommendationItem.type === 9  //review from other all checks below logic
    const GallaryDetailsScreen = recommendationItem?.type === 4 || recommendationItem?.type === 5 || recommendationItem?.type == 6 || recommendationItem?.type === 7
    navigateToScreen("", recommendationItem);
    setTimeout(function () {
      setState((prevState) => ({
        ...prevState,
        loading: false,
      }));

      console.log("textjjjj", AOD)

      if (GallaryDetailsScreen) {
        navigateToScreen("GalleryDetailsScreen", recommendationItem)
        return;
      }


      if (AudioLiveTv || LiveTV) {
        console.log("DiTV")
        navigateToScreen("TvRadioDetailsScreen", recommendationItem);
        return;
      }
      if (LiveEvent) {
        console.log("DiTV")
        navigateToScreen("LiveEventDetailsScreen", recommendationItem);
        return;
      }
      if (VOD || AOD) {
        console.log("text1", VOD)
        navigateToScreen("HomeDetailsScreen", recommendationItem)
        return;
      }
    }, 100);
  };

  const AppInAppDataResponse = (status, dataresponse) => {
    if (status === "success") {
      window.appinappDataResponse = dataresponse;
      setState((prevState) => ({
        ...prevState,
        appinappData: dataresponse,
        shouldFocus: true,
        shouldFocusToGrid: true,
      }));
    }
  };

  const lastFocusedElement1 = () => {
    console.log("lastFocusedElement1....", lastFocusedElement);
    setState((prevState) => ({
      ...prevState,
      lastFocusedElement: shouldFocusSlider
        ? "Slider"
        : shouldFocusToRowList
        ? "RowList"
        : "AnimatedGrid",
    }));
  };

  const screenNavigation = (p = "") => {
    navigate("");
  };
  const filteredCategories = Array.isArray(filterTags)
    ? filterTags.filter((item) => item?.disableTv === 1)
    : [];

  console.log(
    "filteredCategories",
    filteredCategories,
    "filterTags",
    filterTags
  );

  console.log(screen,"Screenoo")

 if (screen == "TvRadioDetailsScreen") {
    return (
      <TvRadioDetailsScreen
        handleBack={handleBack}
        data={data}
        isError={isError}
        isLogedIn={isLogedIn}
        navigate={navigate}
        detailToDetail={detailToDetail}
        selectedTag={selectedTag}
        shouldAuthError={shouldAuthError}
        isLiveEvent={
          liveEventData && liveEventData.length > 0 && dsply === "flex"
            ? true
            : false
        }
         premiumQr={premiumQr}
      />
    );
  }
  if (screen == "LiveEventDetailsScreen") {
    return (
      <LiveEventDetailsScreen
        handleBack={handleBack}
        data={data}
        isError={isError}
        isLogedIn={isLogedIn}
        navigate={navigate}
        detailToDetail={detailToDetail}
        selectedTag={selectedTag}
        shouldAuthError={shouldAuthError}
        isLiveEvent={
          liveEventData && liveEventData.length > 0 && dsply === "flex"
            ? true
            : false
        }
         premiumQr={premiumQr}
      />
    );
  }
  
  
  else if (screen === "HomeDetailsScreen") {
    console.log("HomeDetailsScreen....", data);
    return (
      <HomeDetailsScreen
        handleBack={handleBack}
        data={data}
        isError={isError}
        isLogedIn={isLogedIn}
        navigate={navigate}
        detailToDetail={detailToDetail}
        selectedTag={selectedTag}
        shouldAuthError={shouldAuthError}
        isLiveEvent={
          liveEventData && liveEventData.length > 0 && dsply === "flex"
            ? true
            : false
        }
         premiumQr={premiumQr}
      />
    );
  }

 else if (screen === "GallaryDetailsScreen") {
    console.log("HomeDetailsScreen....", data);
    return (
      <GallaryDetailsScreen
        handleBack={handleBack}
        data={data}
        isError={isError}
        isLogedIn={isLogedIn}
        navigate={navigate}
        detailToDetail={detailToDetail}
        selectedTag={selectedTag}
        shouldAuthError={shouldAuthError}
        isLiveEvent={
          liveEventData && liveEventData.length > 0 && dsply === "flex"
            ? true
            : false
        }
         premiumQr={premiumQr}
      />
    );
  }

  else{
        return (
      <div style={styles.homeScreenContainer}>
        {loading && <LoaderScreen />}

        {/* <SliderBanner
          bannerdata={bannerdata}
          /> */}
        {/* Only render ScreenBGItemScreen and CustomGridScreen if data is available */}
        {filterTags && dsply !== "flex" && !isAppInAppOpen && (
          <div
            onMouseEnter={() => {
              if (!shouldFocusToRowList) {
                  FocusHandler("RowList");
              }
            }}
            style={{
              display: shouldHideTopMenu,
              position: "absolute",
              marginTop: "1rem",
              width: "1802px",
              height: "75px",
              overflow: "hidden",
              marginLeft: "7rem",
              zIndex: zindx,
            }}
          >
            <RowList
              rowWidth="100%"
              rowHeight="70px"
              columnWidth="50%"
              columnHeight="70px"
              itemWidth="280px"
              itemHeight="70px"
              animationSpeed={300}
              bgColor="transparent"
              borderColor={shouldFocusToRowList ? "#EC008C" : "#EC008C"}
              // borderColor="#0E1653"
              border="2px solid #fff"
              borderRadius="50px"
              fontSize="26px"
              fontColor="#FFFFFF"
              selectionStyle="background"
              gapBetweenColumn={15}
              shouldFocus={shouldFocusToRowList}
              FocusHandler={FocusHandler}
              handleLeftButton={handleLeftButton}
              RowlListcallBack={RowlListcallBack}
              handleBackButton={handleBackButton}
              handleRowListUpButton={handleRowListUpButton}
              handleRowListDownButton={handleRowListDownButton}
              data={filteredCategories} // Adjust this if 'content' is the field you want to display
              activeStyle={"border"}
              lastFocusedElementRowList={lastFocusedElementRowList}
              rememberFocusItem={rememberFocusItem}

              // RememberFocusRowList={RememberFocusRowList}
              // rememberFocus={rememberFocus}
              // setRememberFocus={setRememberFocus}
            />
          </div>
        )}

        {bannerdata && griddata && dsply !== "flex" && !isAppInAppOpen && (
          <div
            onMouseEnter={() => {
              if (!shouldFocusToGrid) {
                  FocusHandler("AnimatedGrid");
              }
            }}
          >
            <AnimatedGrid
              loaderSet={setState}
              isGridCalled={isGridCalled}
              isChild={false}
              data={griddata}
              data2={griddata}
              filterTags={filterTags}
              recomenddata={recomenddata}
              recomenddataFeed={recomenddataFeed}
              columnCount={resolution === "FHD" ? 7 : 7}
              rowHeight={resolution === "FHD" ? 373 : 249}
              rowWidth={"100%"}
              columnWidth={resolution === "FHD" ? 238 : 159}
              columnHeight={resolution === "FHD" ? 300 : 200}
              thumbnailWidth={resolution === "FHD" ? 228 : 142}
              thumbnailHeight={resolution === "FHD" ? 291 : 194}
              gapX={8.5}
              gapY={0}
              selectionColor={"#FF671F"}
              scrollDuration={100}
              defaultRowCount={1}
              horizontalScrollStartIndex={1}
              selectionStyle={"border"} // or 'zoom'
              gridContainerX={resolution === "FHD" ? "118px" : "79px"}
              // gridContainerY={"65.5vh"}
              gridContainerY={"10vh"}
              gridContainerWidth={"95vw"}
              // gridContainerHeight={"90vh"}
              gridContainerHeight={"100%"}
              gridContainerBgColor={"transparent"}
              shouldFocus={shouldFocusToGrid}
              navigate={navigateToScreen}
              FocusHandler={FocusHandler}
              callBack={callBack}
              isLogedIn={isLogedIn}
              shouldFocusSlider={shouldFocusSlider}
              navigateScreen={Home_Navigate}
              hideRowlist={HideRowList}
              screenNavigation={screenNavigation}
              chageAppInAppStatus={chageAppInAppStatus}
              AppInAppDataResponse={AppInAppDataResponse}
              bannerdata={bannerdata}
              lastFocusedElement1={lastFocusedElement1}
              rememberFocus={rememberFocus}
              lastFocusedElement={lastFocusedElement}
              setRememberFocus={setRememberFocus}
              shouldShowBanner={shouldShowBanner}
              sliderData={sliderData}
            />
          </div>
        )}
        {liveEventData &&
          liveEventData.length > 0 &&
          dsply === "flex" &&
          !isAppInAppOpen && (
            <LiveEventsHome
              data={liveEventData}
              dsply={dsply}
              FocusHandler={FocusHandler}
              navigateToScreen={navigateToScreen}
              IsLiveEvent={true}
            />
          )}
        {isAppInAppOpen && dsply !== "flex" && (
          <AppInApp
            appinappData={appinappData}
            itemDetails={appinappData}
            columnCount={resolution === "FHD" ? 7 : 7}
            rowHeight={resolution === "FHD" ? 373 : 249}
            rowWidth={"100%"}
            columnWidth={resolution === "FHD" ? 238 : 159}
            columnHeight={resolution === "FHD" ? 300 : 200}
            thumbnailWidth={resolution === "FHD" ? 228 : 142}
            thumbnailHeight={resolution === "FHD" ? 291 : 194}
            gapX={8.5}
            gapY={0}
            selectionColor={"#FF671F"}
            scrollDuration={100}
            defaultRowCount={1}
            horizontalScrollStartIndex={1}
            selectionStyle={"border"} // or 'zoom'
            gridContainerX={resolution === "FHD" ? "118px" : "79px"}
            gridContainerY={"65.5vh"}
            gridContainerWidth={"95vw"}
            gridContainerHeight={"90vh"}
            gridContainerBgColor={"transparent"}
            shouldFocus={shouldFocusToGrid}
            navigate={navigateToScreen}
            FocusHandler={FocusHandler}
            callBack={callBack}
          />
        )}
        {console.log("isLogedIn....", isLogedIn)}
        {!liveEventData && !isAppInAppOpen && (
          <MenuScreen
            navigate={navigateToScreen}
            handleMenuselection={handleMenuselection}
            shouldCloseMenu={shouldCloseMenu}
            handleRightButton={handleRightButton}
            isLogedIn={isLogedIn}
            appNavigate={navigate}
            handleLogin={handleLogin}
            handleLogout={handleLogout}
            handleExit={handleExit}
          />
        )}
        <ErrorScreen errorIcon={errorIcon} disply={isError ? "flex" : "none"} />
        <ModalScreen
          shouldShowError={shouldShowError}
          shouldAuthError={shouldAuthError}
          errTitle={shouldAuthError ? "" : errTitle}
          errDescription={errDescription}
          errIcon={errIcon}
          button={button}
          iconWdth={iconWdth}
          iconHeight={iconHeight}
          modalOKButtonHandler={modalOKButtonHandler}
          modalCANCELButtonHandler={modalCANCELButtonHandler}
        />
        
      </div>
    );
      
  }
};
export default HomeScreen;